@app.service 'ActivitiesService', ($http, $q, $state, $timeout, localStorageService, csConfig) ->

  @clone = (srcActivityId, title, config) ->
    $http(
      method: 'POST'
      url: "#{csConfig.chefstepsEndpoint}/api/v0/activities/clone"
      data:
        source_activity_id: srcActivityId
        title: title
        config: config
      headers:
        Authorization: "Bearer #{localStorage.getItem('access_token')}"
    )

  @trackPageView = (activityId) ->
    return unless csConfig.foodThinkersActivityTrackingEnabled
    return unless activityId

    $http(
      method: 'PUT'
      url: "#{csConfig.foodThinkersEndpoint}/weborch/users/page-views"
      data:
        source_id: activityId.toString()
        source_type: 'activity'
      headers:
        Authorization: "Bearer #{localStorage.getItem('access_token')}"
        Brand: 'cs'
      transformResponse: (data, headers) ->
        # FoodThinkers API may return plain text instead of JSON
        # Try to parse as JSON, but return raw data if it fails
        try
          return JSON.parse(data) if data
        catch
          return data
        return data
    )

  @addBookmark = (activityId) ->
    return unless activityId

    $http(
      method: 'PUT'
      url: "#{csConfig.foodThinkersEndpoint}/weborch/users/bookmarks"
      data:
        source_id: activityId.toString()
        source_type: 'activity'
      headers:
        Authorization: "Bearer #{localStorage.getItem('access_token')}"
        Brand: 'cs'
      transformResponse: (data, headers) ->
        # FoodThinkers API may return plain text instead of JSON
        # Try to parse as JSON, but return raw data if it fails
        try
          return JSON.parse(data) if data
        catch
          return data
        return data
    )

  @removeBookmark = (activityId) ->
    return unless activityId

    $http(
      method: 'DELETE'
      url: "#{csConfig.foodThinkersEndpoint}/weborch/users/bookmarks"
      params:
        source_id: activityId.toString()
        source_type: 'activity'
      headers:
        Authorization: "Bearer #{localStorage.getItem('access_token')}"
        Brand: 'cs'
      transformResponse: (data, headers) ->
        # FoodThinkers API may return plain text instead of JSON
        # Try to parse as JSON, but return raw data if it fails
        try
          return JSON.parse(data) if data
        catch
          return data
        return data
    )

  @getBookmarks = ->
    $http(
      method: 'GET'
      url: "#{csConfig.foodThinkersEndpoint}/weborch/users/bookmarks"
      headers:
        Authorization: "Bearer #{localStorage.getItem('access_token')}"
        Brand: 'cs'
        'cache-control': 'no-cache, no-store, must-revalidate'
    )

  this